// extracted by mini-css-extract-plugin
export var alpha = "_fx-4";
export var alphaInputContainer = "_fx-j";
export var badge = "_fx-b";
export var brandKitGrid = "_fx-l";
export var brandKitItem = "_fx-m";
export var brandKitSwatch = "_fx-n";
export var controls = "_fx-5";
export var formatDropdown = "_fx-h";
export var formatSelector = "_fx-g";
export var hex = "_fx-6";
export var hexInput = "_fx-i";
export var hue = "_fx-3";
export var hueAndAlphaPointer = "_fx-a";
export var percentageLabel = "_fx-k";
export var picker = "_fx-0";
export var rgba = "_fx-8";
export var rgbaSection = "_fx-7";
export var saturation = "_fx-1";
export var saturationPointer = "_fx-9";
export var sliders = "_fx-2";
export var swatch = "_fx-c";
export var swatchDisabled = "_fx-f";
export var swatchRing = "_fx-d";
export var swatchTransparent = "_fx-e";